























































































import { BrowserMultiFormatReader } from '@zxing/browser';
import { mapGetters, mapActions } from 'vuex';
import IosSelectMini from '../../components/iosSelect.vue';
import { maybeEnableConsole, enableOverlayConsole, debugLog } from '../../utils/consoleMobile';

export default {
	name: 'stock',
	components: { IosSelectMini },
	data() {
		return {
			// buscador
			searchText: '',
			searchKey: 0,
			selectedCodalfa: null,
			// escáner
			scanning: false,
			scanHandled: false,
			scanToken: 0,
			// cards
			producto: null,
			cantidad: null,
			// código manual
			barcodeManual: '',
			reader: null,
			streamTrack: null,
			// linterna
			torchOn: false,
			torchSupported: false,
			// refrescando
			isRefreshing: false,
			// error
			error: null,
			// confirmar
			isConfirming: false,
			playLock: null as Promise<void> | null,
		};
	},
	computed: {
		...mapGetters('stock', ['items', 'isSearching']),
		searchResults() {
			return this.items || [];
		},
	},
	watch: {
		producto(nuevo) {
			if (nuevo) this.focusCantidadSoon();
		},
	},
	methods: {
		...mapActions('stock', ['fetchByDescri', 'fetchByBarcode', 'cancelSearch', 'confirmarStock']),
		//============================================= Aviso de refresco =========================================//
		// --- Hint por sesión (se reinicia al reabrir la app/ventana) ---
		getSessionHintKey(): string {
			return 'stock_refresh_hint_shown_session';
		},
		wasSessionHintShown(): boolean {
			try {
				return sessionStorage.getItem(this.getSessionHintKey()) === '1';
			} catch (e) {
				return false;
			}
		},
		markSessionHintShown(): void {
			try {
				sessionStorage.setItem(this.getSessionHintKey(), '1');
			} catch (e) {}
		},
		isAndroid(): boolean {
			try {
				return /Android/i.test(navigator.userAgent || '');
			} catch (e) {
				return false;
			}
		},
		showRefreshHintOncePerSession(): void {
			// Mostramos solo en Android, una única vez por sesión
			if (!this.isAndroid()) return;
			if (this.wasSessionHintShown()) return;

			const self = this;
			setTimeout(function () {
				try {
					if (!self.scanning) return; // solo si está el escáner abierto
					self.$message.info('Si la cámara no escanea, tocá “Refrescar”.');
					self.markSessionHintShown();
				} catch (e) {}
			}, 2200);
		},

		//============================================= Helpers para ios =========================================//
		playIfNeeded(video: HTMLVideoElement): Promise<void> {
			try {
				// si ya está reproduciendo, salir
				const isPlaying = !video.paused && !video.ended && video.readyState >= 2;
				if (isPlaying) return Promise.resolve();

				// si ya hay un play en curso, reusar
				if (this.playLock) return this.playLock;

				const p = (video as any).play();
				// guardo el lock para no llamar play() dos veces
				this.playLock = Promise.resolve(p)
					.catch(() => {}) // no explotar si falla el autoplay
					.finally(() => {
						this.playLock = null;
					});

				return this.playLock;
			} catch (e) {
				return Promise.resolve();
			}
		},
		//iOS only helpers
		isIOS(): boolean {
			const ua = navigator.userAgent || '';
			// Detecta iPhone/iPad/iPod y también iPadOS moderno (que se hace pasar por Mac)
			let isTouchMac = false;
			try {
				isTouchMac = !!(
					(navigator as any).userAgentData === undefined &&
					navigator.maxTouchPoints &&
					navigator.maxTouchPoints > 1 &&
					navigator.userAgent.indexOf('Mac OS X') !== -1
				);
			} catch (e) {}

			return /iPad|iPhone|iPod/.test(ua) || isTouchMac;
		},
		saveBackCamId(id: string) {
			try {
				localStorage.setItem('ios_back_cam_id', id);
			} catch (_) {}
		},
		loadBackCamId(): string | null {
			try {
				return localStorage.getItem('ios_back_cam_id');
			} catch (_) {
				return null;
			}
		},

		async warmupIosOnce(): Promise<void> {
			// Pide permiso 1 vez para que enumerateDevices devuelva labels
			if (!this.isIOS()) return;
			try {
				const existing = this.loadBackCamId();
				if (existing) return;
			} catch (e) {}
			let s: MediaStream | null = null;
			try {
				s = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
			} catch (e) {
				// usuario puede denegar, no es error fatal
			} finally {
				if (s && s.getTracks) {
					try {
						s.getTracks().forEach((t: MediaStreamTrack) => {
							try {
								t.stop();
							} catch (e2) {}
						});
					} catch (e3) {}
				}
			}
		},

		guessIsBackLabel(label: string): boolean {
			const l = (label || '').toLowerCase();
			return (
				l.indexOf('back') !== -1 ||
				l.indexOf('rear') !== -1 ||
				l.indexOf('environment') !== -1 ||
				l.indexOf('trasera') !== -1 ||
				l.indexOf('ultra wide') !== -1 ||
				l.indexOf('telephoto') !== -1 ||
				l.indexOf('wide') !== -1
			);
		},

		async findBackDeviceId(): Promise<string | null> {
			const devices = await navigator.mediaDevices.enumerateDevices();
			const cams = devices.filter((d: any) => d.kind === 'videoinput');
			debugLog('info', 'enumerateDevices()', {
				total: devices.length,
				cams: cams.length,
				list: cams.map(function (c) {
					return { label: c.label, id: (c.deviceId || '').slice(0, 8) + '…' };
				}),
			});
			if (!cams.length) return null;
			const byLabel = cams.find((c: any) => this.guessIsBackLabel(c.label || ''));
			if (byLabel) return byLabel.deviceId;
			if (cams.length >= 2) return cams[cams.length - 1].deviceId;
			const devId = cams[0].deviceId || null;
			debugLog('info', 'camera choice', {
				label: byLabel ? byLabel : cams.length >= 2 ? 'última de varias' : 'única',
				devId: devId ? devId.slice(0, 8) + '…' : null,
			});
			return devId;
		},
		//============================================= Arranque en frio =========================================//
		// Implementa el truco de "calentar" la cámara en Android PWA para solucionar bugs de permisos

		// isAndroidStandalone() {
		// 	try {
		// 		const ua = navigator.userAgent || '';
		// 		const isAndroid = /Android/i.test(ua);
		// 		const standalone =
		// 			(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || (window.navigator as any).standalone === true;
		// 		return isAndroid && standalone;
		// 	} catch (e) {
		// 		return false;
		// 	}
		// },

		// async warmupCameraOnce(): Promise<void> {
		// 	// Usar un flag para no repetir
		// 	try {
		// 		if (localStorage.getItem('cam_warmed') === '1') return;
		// 	} catch (e) {}

		// 	// Si el Permissions API dice 'granted', no hace falta warmup
		// 	try {
		// 		if (navigator.permissions && (navigator.permissions as any).query) {
		// 			const st = await (navigator.permissions as any).query({ name: 'camera' as any });
		// 			if (st && st.state === 'granted') {
		// 				try {
		// 					localStorage.setItem('cam_warmed', '1');
		// 				} catch (e) {}
		// 				return;
		// 			}
		// 		}
		// 	} catch (e) {}

		// 	// Llamada mínima para disparar prompt
		// 	let s: MediaStream | null = null;
		// 	try {
		// 		s = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
		// 	} catch (e) {
		// 		// si el usuario niega, dejamos que startScan maneje el error
		// 		return;
		// 	} finally {
		// 		// cerrar inmediatamente
		// 		if (s && s.getTracks) {
		// 			try {
		// 				s.getTracks().forEach(t => {
		// 					try {
		// 						t.stop();
		// 					} catch (e) {}
		// 				});
		// 			} catch (e) {}
		// 		}
		// 	}

		// 	// marcar como hecho
		// 	try {
		// 		localStorage.setItem('cam_warmed', '1');
		// 	} catch (e) {}
		// },

		// Asegura que el video esté "vivo" o reintenta una vez para solucionar bugs de cuando arranca por primera vez
		async ensureVideoLiveOrRetry(video: HTMLVideoElement, preferDeviceId: string | null) {
			const ok = () => this.isVideoLive(video) && video.videoWidth > 0;
			if (ok()) return;

			// espera corta
			await new Promise(r => setTimeout(r, 250));
			if (ok()) return;

			// Reintento: cerrar stream actual
			const srcObj: any = (video as any).srcObject;
			if (srcObj && typeof srcObj.getTracks === 'function') {
				try {
					const tracks = srcObj.getTracks();
					for (let i = 0; i < tracks.length; i++) {
						try {
							tracks[i].stop();
						} catch (e) {}
					}
				} catch (e) {}
			}
			(video as any).srcObject = null;

			// Reabrir con constraints alternativos
			let constraints: MediaStreamConstraints;
			if (preferDeviceId) {
				constraints = {
					video: { deviceId: { exact: preferDeviceId } as any, width: { ideal: 1920 }, height: { ideal: 1080 } },
					audio: false,
				};
			} else {
				constraints = {
					video: { facingMode: { ideal: 'environment' } as any, width: { ideal: 1920 }, height: { ideal: 1080 } },
					audio: false,
				};
			}

			const s2 = await navigator.mediaDevices.getUserMedia(constraints);
			(video as any).srcObject = s2;
			try {
				await this.playIfNeeded(video);
			} catch (e) {}
		},
		//============================================= Buscador =========================================//
		onOpenDropdown() {},
		onSelectProducto(codalfa) {
			const p = (this.searchResults || []).find(function (x) {
				return x.codalfa === codalfa;
			});
			if (!p) return;
			this.producto = p;
			this.cantidad = typeof p.salcan === 'number' ? p.salcan : 0;
		},
		onQueryChange(q) {
			this.searchText = q || '';
			const t = this.searchText.trim();
			if (t.length < 3) {
				this.cancelSearch();
				return;
			}
			this.fetchByDescri(t);
		},

		//========================================= Escáner =============================================//
		// Añade listeners para debug
		addVideoDebugListeners(video: HTMLVideoElement) {
			const onReady = () => {
				try {
					this.playIfNeeded(video);
				} catch (e) {}
				this.updateTorchSupportFromVideo(video);
			};
			['loadedmetadata', 'canplay'].forEach(ev => {
				video.addEventListener(ev, onReady, { once: true });
			});
		},

		// Actualiza streamTrack y torchSupported
		updateTorchSupportFromVideo(video: HTMLVideoElement): void {
			let track: MediaStreamTrack | null = null;
			const srcObj: any = (video as any).srcObject;
			if (srcObj && typeof srcObj.getVideoTracks === 'function') {
				const arr: MediaStreamTrack[] = srcObj.getVideoTracks();
				if (arr && arr.length) track = arr[0];
			}
			this.streamTrack = track || null;

			let torchSupported = false;
			if (track && typeof (track as any).getCapabilities === 'function') {
				try {
					const caps = (track as any).getCapabilities();
					torchSupported = !!(caps && (caps as any).torch);
				} catch (e) {}
			}
			this.torchSupported = torchSupported;
		},

		// --- Helper: callback seguro atado al token actual ---
		makeZXCallback(myToken: number) {
			const self = this;
			return function (result: any) {
				if (self.scanHandled) return;
				if (self.scanToken !== myToken) return; // callback viejo, ignorar

				let text: any = null;
				try {
					text = result && typeof result.getText === 'function' ? result.getText() : null;
				} catch (e) {}

				if (text) {
					self.scanHandled = true;
					self.onCodeDetected(text);
				}
			};
		},

		async startScan(): Promise<void> {
			debugLog('info', 'startScan()', { ios: this.isIOS() });
			this.error = null;
			this.stopScan();
			this.scanHandled = false;
			this.scanToken++;

			if (!(window as any).isSecureContext) {
				this.error = 'La cámara requiere HTTPS o localhost.';
				return;
			}
			if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
				this.error = 'Este navegador no soporta getUserMedia.';
				return;
			}

			if (this.isIOS()) await this.startScanIOS();
			else {
				// Android / Desktop
				// if (this.isAndroidStandalone()) {
				// 	// tu warmup actual para Android PWA
				// 	await this.warmupCameraOnce();
				// }
				await this.startScanDefault();
			}
		},

		async startScanIOS(): Promise<void> {
			const video = this.$refs.video as HTMLVideoElement;
			if (!video) {
				this.error = 'No se encontró el elemento <video>.';
				return;
			}
			video.setAttribute('playsinline', '');
			video.setAttribute('autoplay', '');
			video.muted = true;
			this.addVideoDebugListeners(video);

			// 1) aseguramos labels y obtenemos/backupeamos la trasera
			await this.warmupIosOnce();
			let devId = this.loadBackCamId();
			if (!devId) {
				devId = await this.findBackDeviceId();
				if (devId) this.saveBackCamId(devId);
			}
			debugLog('info', 'iOS chosen device', { devId: devId ? devId.slice(0, 8) + '…' : null });

			// 2) inicializar ZXing
			debugLog('info', 'ZXing decodeFromVideoDevice', { devId: devId ? devId.slice(0, 8) + '…' : '(undefined)' });
			if (!this.reader) this.reader = new (BrowserMultiFormatReader as any)();
			this.scanning = true;
			this.showRefreshHintOncePerSession();

			// 3) Intento A: ZXing directo por deviceId exact
			const myToken = this.scanToken;
			const cb = this.makeZXCallback(myToken);
			(this.reader as any).decodeFromVideoDevice(devId || undefined, video, cb);

			// 4) Fallback si queda “frío”: abrimos stream manual por deviceId exact
			setTimeout(async () => {
				try {
					const live = this.isVideoLive(video) && video.videoWidth > 0;
					if (live) {
						this.updateTorchSupportFromVideo(video);
						debugLog('info', 'video live tras intento A', { w: video.videoWidth, h: video.videoHeight });
						return;
					}

					// Reiniciamos y forzamos stream manual exacto
					try {
						if (this.reader && typeof (this.reader as any).reset === 'function') (this.reader as any).reset();
					} catch (_) {}
					const chosen = devId || this.loadBackCamId();
					const constraints: MediaStreamConstraints = chosen
						? { video: { deviceId: { exact: chosen } as any, width: { ideal: 1280 }, height: { ideal: 720 } }, audio: false }
						: { video: { facingMode: { ideal: 'environment' } as any, width: { ideal: 1280 }, height: { ideal: 720 } }, audio: false };

					debugLog('info', 'Fallback getUserMedia constraints', constraints);
					const s = await navigator.mediaDevices.getUserMedia(constraints);
					(video as any).srcObject = s;
					try {
						await this.playIfNeeded(video);
					} catch (_) {}
					this.updateTorchSupportFromVideo(video);
					debugLog('info', 'fallback attached', { torchSupported: this.torchSupported });

					const cb2 = this.makeZXCallback(this.scanToken); // no invalida token actual
					const readerAny: any = this.reader;
					if (typeof readerAny.decodeFromStream === 'function') readerAny.decodeFromStream(s, video, cb2);
					else if (typeof readerAny.decodeFromVideoElement === 'function') readerAny.decodeFromVideoElement(video, cb2);
					else readerAny.decodeFromVideoDevice(chosen || undefined, video, cb2);
				} catch (e) {
					debugLog('error', 'fallback failed', { msg: String(e) });
				}
			}, 1200);
		},
		async startScanDefault(): Promise<void> {
			const waitForVideo = (video: HTMLVideoElement, ms = 1500): Promise<void> =>
				new Promise((resolve, reject) => {
					let done = false;
					function ok() {
						if (!done) {
							done = true;
							resolve();
						}
					}
					function fail() {
						if (!done) {
							done = true;
							reject(new Error('timeout'));
						}
					}
					const t = setTimeout(fail, ms);
					function onLoaded() {
						clearTimeout(t);
						ok();
						cleanup();
					}
					function onPlaying() {
						clearTimeout(t);
						ok();
						cleanup();
					}
					function cleanup() {
						video.removeEventListener('loadedmetadata', onLoaded);
						video.removeEventListener('playing', onPlaying);
					}
					video.addEventListener('loadedmetadata', onLoaded);
					video.addEventListener('playing', onPlaying);
					try {
						if (video.readyState >= 2) {
							clearTimeout(t);
							ok();
							cleanup();
						}
					} catch (e) {}
				});

			// reset/inicio
			this.error = null;
			this.stopScan(); // también invalida tokens viejos
			this.scanHandled = false;
			const myToken = ++this.scanToken; // token vigente
			const cb = this.makeZXCallback(myToken);

			if (!(window as any).isSecureContext) {
				this.error = 'La cámara requiere HTTPS o localhost.';
				return;
			}
			if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
				this.error = 'Este navegador no soporta getUserMedia.';
				return;
			}
			// if (this.isAndroidStandalone()) {
			// 	await this.warmupCameraOnce();
			// }

			try {
				// elegir cámara (trasera si está)
				const all = await navigator.mediaDevices.enumerateDevices();
				debugLog('info', 'devices', { total: all.length, cams: all.filter(d => d.kind === 'videoinput').length });
				const cams = all.filter(function (d) {
					return d.kind === 'videoinput';
				});
				if (!cams.length) {
					this.error = 'No hay cámaras disponibles.';
					return;
				}
				const choice =
					cams.find(function (c) {
						return /camera 0, facing back/i.test(c.label);
					}) ||
					cams.find(function (c) {
						return /back|rear|environment/i.test(c.label);
					}) ||
					cams[0];
				const devId = choice && choice.deviceId ? choice.deviceId : null;

				// preparar <video>
				const video = this.$refs.video as HTMLVideoElement;
				if (!video) {
					this.error = 'No se encontró el elemento <video>.';
					return;
				}
				video.setAttribute('playsinline', '');
				video.setAttribute('autoplay', '');
				video.muted = true;
				this.addVideoDebugListeners(video);

				// lector
				if (!this.reader) this.reader = new BrowserMultiFormatReader();
				this.scanning = true;
				this.showRefreshHintOncePerSession();

				// intento A: arrancar ZXing directamente
				(this.reader as any).decodeFromVideoDevice(devId, video, cb);

				// ver si quedó "frío" luego de un rato
				setTimeout(() => {
					try {
						const video = this.$refs.video as HTMLVideoElement;
						const live = this.isVideoLive(video) && video.videoWidth > 0;
						if (!live) {
							// cámara no “prendió” aún → cold kick
							this.coldKick(video, devId);
							return;
						}
						// Está vivo pero ZXing todavía no devolvió nada → reenganchar al mismo <video>
						if (!this.scanHandled) {
							const myTokenCurrent = this.scanToken; // no incrementes el token acá
							const cb2 = this.makeZXCallback(myTokenCurrent);
							const readerAny: any = this.reader;
							if (readerAny && typeof readerAny.decodeFromVideoElement === 'function') readerAny.decodeFromVideoElement(video, cb2);
						}
						// actualizar torch info de todas formas
						this.updateTorchSupportFromVideo(video);
					} catch (e) {}
				}, 1500);

				// intento B: arrancar cámara "a mano"
				let attached = true;
				try {
					await waitForVideo(video, 1500);
					try {
						await this.playIfNeeded(video);
					} catch (e) {}
					this.updateTorchSupportFromVideo(video);
				} catch (e) {
					attached = false;
				}

				if (!attached) {
					try {
						if (this.reader && typeof (this.reader as any).reset === 'function') (this.reader as any).reset();

						const constraints: MediaStreamConstraints = devId
							? { video: { deviceId: { exact: devId } as any } }
							: { video: { facingMode: { ideal: 'environment' } as any } };

						const stream = await navigator.mediaDevices.getUserMedia(constraints);
						(video as any).srcObject = stream;
						try {
							await waitForVideo(video, 1500);
						} catch (e) {}
						try {
							await this.playIfNeeded(video);
						} catch (e) {}
						this.updateTorchSupportFromVideo(video);
						// Paso 2: calentar video si quedó frío
						const preferId = this.isIOS() ? this.loadBackCamId() : null;
						await this.ensureVideoLiveOrRetry(video, preferId);

						const readerAny: any = this.reader as any;
						if (typeof readerAny.decodeFromStream === 'function') readerAny.decodeFromStream(stream, video, cb);
						else if (typeof readerAny.decodeFromVideoElement === 'function') readerAny.decodeFromVideoElement(video, cb);
						else (this.reader as any).decodeFromVideoDevice(devId, video, cb);
					} catch (e) {
						if (!this.error) this.error = 'No se pudo iniciar la cámara. Verificá permisos.';
						this.scanning = false;
					}
				}

				this.updateTorchSupportFromVideo(video);
			} catch (err) {
				this.scanning = false;
				let name = 'Error';
				if (err && typeof err === 'object') {
					const anyErr: any = err;
					if (anyErr && typeof anyErr.name === 'string') name = anyErr.name;
				}
				this.error =
					name === 'NotAllowedError'
						? 'Permiso de cámara denegado. Revisá permisos del navegador.'
						: name === 'NotFoundError'
						? 'No se encontró ninguna cámara en el dispositivo.'
						: 'No se pudo iniciar la cámara. Verificá permisos.';
			}
		},

		stopScan() {
			// Invalida cualquier callback que llegue tarde
			this.scanHandled = true;
			this.scanToken++; // clave para invalidar todos los callbacks viejos

			try {
				this.reader && typeof this.reader.reset === 'function' && this.reader.reset();
			} catch (e) {}

			const video = this.$refs.video as HTMLVideoElement;
			const srcObj: any = video ? (video as any).srcObject : null;

			if (srcObj && typeof srcObj.getTracks === 'function') {
				try {
					const tracks = srcObj.getTracks();
					for (let i = 0; i < tracks.length; i++) {
						try {
							tracks[i].stop();
						} catch (e) {}
					}
				} catch (e) {}
			}

			if (video) (video as any).srcObject = null;

			this.streamTrack = null;
			this.scanning = false;
			this.torchOn = false;
			if (this.isIOS()) setTimeout(() => {}, 120);
		},

		async toggleTorch() {
			if (!this.streamTrack) return;
			try {
				const apply =
					this.streamTrack && typeof this.streamTrack.applyConstraints === 'function'
						? this.streamTrack.applyConstraints.bind(this.streamTrack)
						: null;
				if (!apply) return;
				this.torchOn = !this.torchOn;
				await apply({ advanced: [{ torch: this.torchOn }] });
			} catch (e) {
				this.torchSupported = false;
				this.torchOn = false;
			}
		},

		async onCodeDetected(code) {
			try {
				if (typeof navigator !== 'undefined' && typeof (navigator as any).vibrate === 'function') (navigator as any).vibrate(60);
			} catch (e) {}
			this.stopScan(); // parar la cámara al capturar 1 código

			this.error = null;
			const prod = await this.fetchByBarcode(code);
			if (prod) {
				this.producto = prod;
				this.cantidad = typeof prod.salcan === 'number' ? prod.salcan : 0;
			} else {
				this.$message.error('No se encontró el producto para ese código.');
				this.producto = null;
			}
		},

		isVideoLive(video: HTMLVideoElement): boolean {
			let srcObj: any = (video as any).srcObject;
			if (!srcObj || typeof srcObj.getVideoTracks !== 'function') return false;
			try {
				let tracks = srcObj.getVideoTracks();
				if (!tracks || !tracks.length) return false;
				for (let i = 0; i < tracks.length; i++) if (tracks[i] && tracks[i].readyState === 'live') return true;
			} catch (e) {}
			return false;
		},

		async coldKick(video: HTMLVideoElement, devId: string | null) {
			// si ya está vivo, no hacemos nada
			if (this.isVideoLive(video) && video.videoWidth > 0) return;

			const myToken = this.scanToken; //token vigente

			try {
				// Reiniciar ZXing
				try {
					if (this.reader && typeof this.reader.reset === 'function') this.reader.reset();
				} catch (e) {}

				let constraints: MediaStreamConstraints = devId
					? { video: { deviceId: { exact: devId } as any, width: { ideal: 1280 }, height: { ideal: 720 } } }
					: { video: { facingMode: { ideal: 'environment' } as any, width: { ideal: 1280 }, height: { ideal: 720 } } };

				let stream = await navigator.mediaDevices.getUserMedia(constraints);
				(video as any).srcObject = stream;
				debugLog('info', 'stream attached');
				try {
					await this.playIfNeeded(video);
				} catch (e) {}

				const cb = this.makeZXCallback(myToken);
				let readerAny: any = this.reader;
				if (readerAny && typeof readerAny.decodeFromStream === 'function') readerAny.decodeFromStream(stream, video, cb);
				else if (readerAny && typeof readerAny.decodeFromVideoElement === 'function') readerAny.decodeFromVideoElement(video, cb);
				else (this.reader as any).decodeFromVideoDevice(devId, video, cb);

				this.updateTorchSupportFromVideo(video);
				debugLog('info', 'torch?', { supported: this.torchSupported });
			} catch (e) {
				const err: any = e;
				const name = err && err.name ? err.name : 'Error';
				const msg = err && err.message ? err.message : String(err);
				debugLog('error', 'getUserMedia failed', { name, msg });
			}
		},
		async refreshScan() {
			if (this.isRefreshing) return;
			this.isRefreshing = true;
			try {
				debugLog('info', 'refreshScan() begin');
				this.stopScan();
				await new Promise(r => setTimeout(r, 300));
				await this.startScan();
				debugLog('info', 'refreshScan() done');
			} catch (e) {
				const err: any = e || {};
				debugLog('error', 'refreshscan() failed', { name: err.name, msg: String(e) });
				this.$message.error('No se pudo reiniciar la cámara');
			} finally {
				this.isRefreshing = false;
			}
		},

		//==================================== Buscar por código manual ========================================//
		async buscarPorCodigo() {
			const code = (this.barcodeManual || '').trim().toUpperCase();
			if (!code) return;

			this.error = null;
			const prod = await this.fetchByBarcode(code);
			if (prod) {
				this.producto = prod;
				this.cantidad = typeof prod.salcan === 'number' ? prod.salcan : 0;
			} else {
				this.$message.error('No se encontró el producto para ese código.');
				this.producto = null;
			}
		},

		onProductoElegido(prod) {
			this.producto = prod;
			this.cantidad = 0;
			this.stopScan();
		},

		//==================================== Confirmar ajuste de stock ========================================//
		async confirmar() {
			if (this.isConfirming) return;
			try {
				if (!this.producto || !this.producto.codalfa) {
					this.$message.error('No hay producto seleccionado');
					return;
				}
				this.isConfirming = true;
				await this.confirmarStock({
					codalfa: this.producto.codalfa,
					cantidad: Number(this.cantidad),
					codemp: 1,
					coddep: 1,
				});
				this.$message.success('Stock guardado');
				this.reset();
			} catch (e) {
				this.$message.error('No se pudo guardar');
			} finally {
				this.isConfirming = false;
			}
		},

		reset() {
			// 1) invalidar callbacks pendientes antes de limpiar
			this.scanHandled = true;
			this.scanToken++;

			// 2) limpiar UI/estado
			this.producto = null;
			this.cantidad = null;
			this.barcodeManual = '';
			this.error = null;
			this.selectedCodalfa = null;

			// 3) detener cámara/decoder
			this.stopScan();

			// 4) limpiar resultados de búsqueda
			try {
				this.cancelSearch();
			} catch (e) {}

			this.searchKey = this.searchKey + 1;

			// 5) si querés volver a habilitar escaneo inmediatamente:
			this.$nextTick(() => {
				this.scanHandled = false;
			});
		},

		onDropdownVisibleChange(isOpen) {
			if (!isOpen) {
				try {
					this.cancelSearch();
				} catch (e) {}
			}
		},

		// focus en input de cantidad
		focusCantidadSoon() {
			this.$nextTick(() => {
				setTimeout(() => {
					const num: any = this.$refs.cantidadInput;
					if (!num) return;

					let el: any = null;
					try {
						const elInputComp = num.$refs && num.$refs.input;
						if (elInputComp && typeof elInputComp.focus === 'function') elInputComp.focus();
						el = elInputComp && elInputComp.$refs && elInputComp.$refs.input;
					} catch (_) {}

					if (!el) el = num.$el && num.$el.querySelector && num.$el.querySelector('input');

					if (el && typeof el.focus === 'function') {
						el.focus();
						try {
							const v = String(this.cantidad == null ? '' : this.cantidad);
							if (el.setSelectionRange && v) el.setSelectionRange(v.length, v.length);
						} catch (_) {}
						try {
							el.scrollIntoView({ block: 'center', behavior: 'smooth' });
						} catch (_) {}
					}
				}, 50);
			});
		},
	},
	mounted() {
		// enableOverlayConsole({ max: 400 });
		debugLog('info', 'Stock view mounted');
	},
	beforeDestroy() {
		this.stopScan();
	},
};
